"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextLabel = require('../textLabel');

var GooglePreview = function GooglePreview(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-google-preview'),
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: props.title,
    shouldTranslate: props.shouldTranslate
  })), /*#__PURE__*/React.createElement("div", {
    className: "url"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: props.url,
    shouldTranslate: props.shouldTranslate
  })), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: props.description,
    shouldTranslate: props.shouldTranslate,
    enableEllipsis: false
  }))));
};

GooglePreview.displayName = displayNames.GOOGLE_PREVIEW;
GooglePreview.propTypes = {
  /** Ad title */
  title: PropTypes.string.isRequired,

  /** Ad url */
  url: PropTypes.string.isRequired,

  /** Ad description */
  description: PropTypes.string.isRequired
};
module.exports = compose(GooglePreview);